import {type RunningTime, RunningTimeType} from '@hconnect/common/types'

export const getUndefinedStoppages = (runningTimes?: RunningTime[]) =>
  runningTimes?.filter(
    (rt) => rt.runningTimeType === RunningTimeType.STOPPED && rt.stoppages === undefined
  ) || []

export function getNextItem(
  currentUndefinedStoppages: RunningTime[] | undefined,
  currentIndex: number | undefined
) {
  if (
    !currentUndefinedStoppages ||
    currentIndex === undefined ||
    currentIndex >= currentUndefinedStoppages.length - 1
  )
    return undefined
  return currentUndefinedStoppages[currentIndex + 1]
}

export function getPrevItem(
  currentUndefinedStoppages: RunningTime[] | undefined,
  currentIndex: number | undefined
) {
  if (!currentUndefinedStoppages || currentIndex === undefined || currentIndex <= 0)
    return undefined
  return currentUndefinedStoppages[currentIndex - 1]
}
